import React, { useEffect } from 'react'
import Header from '../../components/Header'
import Footer from '../../components/Footer';
import StatsSection from '../../components/StatsSection';
import ProcessSection from '../../components/ProcessSection';
import Newsletter from '../../components/Newsletter';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import { Helmet } from "react-helmet";

const FaqItem = ({ question, answer, defaultOpen = false }) => {
  const [open, setOpen] = React.useState(defaultOpen);
  return (
    <div className="accordion-item">
      <h2 className="accordion-header">
        <button
          className={`accordion-button ${open ? '' : 'collapsed'}`}
          type="button"
          onClick={() => setOpen(prev => !prev)}
        >
          {question}
        </button>
      </h2>
      <div className={`accordion-collapse collapse ${open ? 'show' : ''}`}>
        <div className="accordion-body">{answer}</div>
      </div>
    </div>
  );
};

export default function CustomEmbroideryDigitizing() {

    const customEmbSteps = [
        { number: "01", title: "Submit Your Design", description: "Share your artwork in any format such as JPG, PNG, PDF, or AI.", icon: "📤" },
        { number: "02", title: "Custom Digitizing", description: "Our experts create a tailored embroidery file based on your design and requirements.", icon: "⚡" },
        { number: "03", title: "Quality Optimization", description: "We refine stitch paths, density, and details for flawless embroidery results.", icon: "✓" },
        { number: "04", title: "File Delivery", description: "Receive your embroidery file in formats like DST, PES, JEF, and more.", icon: "🚀" }
    ];

    return (
        <>

            <Helmet>
                <title>Custom Embroidery Digitizing Services Los Angeles, CA | Grand Indigo Embroidery</title>
                <meta name="description" content="Order custom embroidery digitizing services in Los Angeles, CA. Get precise logo digitizing tailored to your design. Fast, reliable & affordable service." />
                <meta name="keywords" content="custom embroidery digitizing, custom logo digitizing, embroidery digitizing services, professional embroidery digitizing, online embroidery digitizing, Los Angeles embroidery digitizing, digitizing services near me" />
            </Helmet>

            <Header />

            <section className="breadcrumbsection">
                <div className='container'>
                    <h1>Custom Embroidery Digitizing</h1>
                    <ul className='breadcrumblinks'>
                        <li><Link to="/">Home</Link></li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>Services</li>
                        <li><FontAwesomeIcon icon={faChevronRight} /></li>
                        <li>CustomEmbroidery Digitizing</li>
                    </ul>
                </div>
            </section>


            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/custom-digitizing1.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Tailored Stitch Solutions</span>
                                <h3 className="case-study-title">Custom Embroidery Digitizing Services in Los Angeles</h3>
                                <p className="case-study-description">
                                    At Grand Indigo Embroidery, we provide specialized custom embroidery digitizing services in Los Angeles, California, tailored to meet the unique needs of businesses, brands, and embroidery professionals. Every design is different, and our approach ensures that your artwork is carefully converted into a high-quality embroidery file that delivers clean, accurate, and consistent stitching results.
                                </p>
                                <p className="case-study-description">
                                    Whether you have a detailed logo, intricate artwork, or a custom concept, our expert digitizers analyze every element to determine the best stitch types, density, and sequencing. This ensures your design translates perfectly onto garments, caps, uniforms, and promotional products. If you're looking for reliable custom embroidery digitizing near you in Los Angeles, Grand Indigo Embroidery provides precision-driven solutions that maintain the integrity of your original design.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <StatsSection />

            <section className="service-section">
                <div className="container">
                    <div className="row align-items-center mb-5">
                        <div className="col-lg-6">
                            <div className="case-study-content">
                                <span className="case-study-tag">Designed for Your Unique Needs</span>
                                <h3 className="case-study-title">Tailored Logo Digitizing for Unique Designs</h3>
                                <p className="case-study-description">
                                    Our custom logo embroidery digitizing services are designed to handle everything from simple branding elements to highly complex designs. We understand that factors like fabric type, design placement, and embroidery style all influence the final result, which is why we customize every file to suit its specific application.
                                </p>
                                <p className="case-study-description">
                                    From small chest logos to large back designs and specialty embroidery styles, we ensure every stitch is optimized for professional output. Businesses across Los Angeles trust us for our attention to detail, fast turnaround, and consistent quality. Whether you need to order custom embroidery digitizing online or want a dependable local partner, Grand Indigo Embroidery delivers results that meet industry standards and exceed expectations.
                                </p>
                                <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
                            </div>
                        </div>
                        <div className="col-lg-6 mb-4 mb-lg-0">
                            <div className="case-study-image">
                                <img src="/images/services/custom-digitizing2.jpg" alt="Custom Uniform Embroidery" />
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <ProcessSection steps={customEmbSteps} />

            <section className="faqs-section">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-12 text-center">
                            <h2 className="section-title">Frequently Asked Questions</h2>
                        </div>
                    </div>

                    <div className="row justify-content-center">
                        <div className="col-lg-10">
                            <div className="accordion" id="faqAccordion">

                                <FaqItem
                                    defaultOpen={true}
                                    question="What is custom embroidery digitizing?"
                                    answer="Custom embroidery digitizing is the process of converting unique designs into machine-readable stitch files tailored specifically for embroidery applications."
                                />

                                <FaqItem
                                    question="Do you offer custom embroidery digitizing services in Los Angeles?"
                                    answer="Yes, Grand Indigo Embroidery provides expert custom embroidery digitizing services in Los Angeles, California, for both local and online clients."
                                />

                                <FaqItem
                                    question="Can I order custom embroidery digitizing online?"
                                    answer="Absolutely. You can easily submit your design and order custom embroidery digitizing online with a fast turnaround."
                                />

                                <FaqItem
                                    question="How long does custom embroidery digitizing take?"
                                    answer="Most custom digitizing projects are completed within 12–24 hours depending on the complexity of the design."
                                />

                                <FaqItem
                                    question="What types of designs can you digitize?"
                                    answer="We can digitize logos, artwork, text, monograms, and complex custom designs for all types of embroidery applications."
                                />

                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Newsletter />

            <Footer />
        </>
    )
}
